<template>
  <div>
    <v-container>
      <v-row>
        <v-col :class="classPadding">
          <span>Report Type:</span>
          <v-radio-group row v-model="reportType" :class="classPadding">
            <v-radio label="Base on Employee Masterfile" value="emp"></v-radio>
            <v-radio label="Base on PME History" value="pme"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date From"
            v-model="dateFrom"
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date To"
            v-model="dateTo"
          ></custom-datepicker>
        </v-col>
      </v-row>
      <v-expansion-panels multiple v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-model="payLoc"
              :by-user="true"
            ></pay-loc-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection
              :show-dense="false"
              :show-select="true"
              v-model="department"
            ></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection
              :show-dense="false"
              :show-select="true"
              v-model="division"
            ></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection
              :show-dense="false"
              :show-select="true"
              v-model="branch"
            ></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection
              :show-dense="false"
              :show-select="true"
              v-model="section"
            ></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Status</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group row v-model="group" :class="classPadding">
              <v-radio label="All" value="2"></v-radio>
              <v-radio
                label="Active"
                value="1"
                v-if="reportType == 'emp'"
              ></v-radio>
              <v-radio
                label="Inactive"
                value="0"
                v-if="reportType == 'emp'"
              ></v-radio>
              <v-radio
                label="On Board"
                value="0"
                v-if="reportType == 'pme'"
              ></v-radio>
              <v-radio
                label="Resigned"
                value="1"
                v-if="reportType == 'pme'"
              ></v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col>
          <v-radio-group row v-model="group2" :class="classPadding">
            <v-radio
              label="Personal Info"
              value="Personal"
              v-if="reportType == 'emp'"
            ></v-radio>
            <v-radio label="Employment Info" value="Employment"></v-radio>
            <v-radio label="Master List" value="Master"></v-radio>
            <v-radio label="PME Level Masterlist" value="PmeMaster"></v-radio>
            <v-radio
              label="All"
              value="All"
              v-if="reportType == 'emp'"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="group2 == 'Employment'">
        <v-col :class="classPadding">
          <span>SORT BY:</span>
          <v-radio-group row v-model="sortBy" :class="classPadding">
            <v-radio label="Per Employee Code" value="0"></v-radio>
            <v-radio label="Per Employee Name" value="1"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          :class="classPadding"
          cols="12"
          xs="12"
          md="12"
          sm="12"
          v-if="sortBy == '1'"
        >
          <span>Group By</span>
          <v-checkbox
            label="Per Department"
            :class="classPadding"
            v-model="groupBy"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          :class="classPadding"
          cols="12"
          xs="12"
          md="12"
          sm="12"
          v-if="group2 == 'All'"
        >
          <v-checkbox
            label="Remove leading zero for employee code"
            :class="classPadding"
            v-model="leadingZero"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="group2 == 'Master'">
        <v-col :class="classPadding" cols="12" xs="12" md="3" sm="6">
          <v-text-field
            label="Checked By"
            :class="classPadding"
            v-model="checkBy"
          ></v-text-field>
        </v-col>
        <v-col :class="classPadding" cols="12" xs="12" md="3" sm="6">
          <v-text-field
            label="Position"
            :class="classPadding"
            v-model="checkByPos"
          ></v-text-field>
        </v-col>

        <v-col :class="classPadding" cols="12" xs="12" md="3" sm="6">
          <v-text-field
            label="Note By"
            :class="classPadding"
            v-model="notedBy"
          ></v-text-field>
        </v-col>
        <v-col :class="classPadding" cols="12" xs="12" md="3" sm="6">
          <v-text-field
            label="Position"
            :class="classPadding"
            v-model="notedByPos"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- eslint-disable no-redeclare -->
<!-- eslint-disable no-console -->
<script>
import moment from "moment";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/NewSelection"
  );

const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/NewSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/NewSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/NewSelection"
  );
const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    isSearching: false,
    employees: [],
    headers: [
      {
        text: "Code",
        value: "empCode",
        sortable: false
      },
      {
        text: "Last Name",
        value: "lName",
        sortable: false
      },
      {
        text: "First Name",
        value: "fName",
        sortable: false
      },
      {
        text: "Middle Name",
        value: "mName",
        sortable: false
      }
    ],
    loading: false,
    group: "2",
    group2: "Personal",
    panel: [5],
    reportType: "emp",
    sortBy: "empCode",
    groupBy: false,
    leadingZero: false,
    checkBy: null,
    checkByPos: null,
    notedBy: null,
    notedByPos: null
  }),
  components: {
    CustomDatepicker,
    PayLocSelection,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection
  },
  computed: {
    grp() {
      return this.payLoc.join(", ");
    },
    dep() {
      return this.department.join(", ");
    },
    div() {
      return this.division.join(", ");
    },
    bra() {
      return this.branch.join(", ");
    },
    sec() {
      return this.section.join(", ");
    }
  },
  methods: {
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
    },
    exportReport() {
      this.loading = true;
      var data = {
        Grp: this.grp,
        Dep: this.dep,
        Bra: this.bra,
        Div: this.div,
        Sec: this.sec,
        Stat: this.group,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        ReportType: this.reportType,
        Sortby: this.sortBy,
        Groupby: this.groupBy,
        Group2: this.group2,
        CheckBy: this.checkBy,
        CheckByPos: this.checkByPos,
        NotedBy: this.notedBy,
        NotedByPos: this.notedByPos,
        LeadingZero: this.leadingZero
      };

      var url = "";
      if (this.group2 == "All") {
        url = `${API_ENDPOINT}/employmee-masterfile-info-wo-salary/all/${this.group2}`;
      } else if (this.group2 == "Master") {
        url = `${API_ENDPOINT}/employmee-masterfile-info-wo-salary/${this.group2}`;
      } else if (this.group2 == "PmeMaster") {
        url = `${API_ENDPOINT}/pme-level-setup`;
      } else {
        url = `${API_ENDPOINT}/employmee-masterfile-info`;
      }

      if (this.group2 === "All") {
        this.$axios
          .post(url, data, { responseType: "blob" })
          .then(({ data }) => {
            var nameOfTheCsv = "PersonalInformation.xlsx";
            const downloadUrl = window.URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", nameOfTheCsv);
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch(({ response }) => {
            const reader = new FileReader();
            var vue = this;
            reader.onload = function() {
              const errorData = JSON.parse(reader.result);
              vue.$toast.error(errorData.message);
            };

            reader.readAsText(response.data);
          })
          .finally(() => {
            this.loading = false;
          });
        return;
      }
      this.$axios
        .post(url, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;
          if (this.group2 == "All") {
            // window.open(
            //   `${subPath.slice(
            //     0,
            //     -1
            //   )}${API_ENDPOINT}/employmee-masterfile-info/all/${data}`
            // );
            var nameOfTheCsv = "PersonalInformation.xlsx";

            this.$axios
              .post(`${API_ENDPOINT}/employmee-masterfile-info/all/${data}`, {
                responseType: "blob"
              })
              .then(response => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch(err => console.log(err));
          } else if (this.group2 == "Master") {
            // window.open(
            //   `${subPath.slice(
            //     0,
            //     -1
            //   )}${API_ENDPOINT}/employmee-masterfile-info/${data}`
            // );

            var nameOfTheCsv = "EmployeeMasterLists.xlsx";
            this.$axios
              .get(`${API_ENDPOINT}/employmee-masterfile-info/${data}`, {
                responseType: "blob"
              })
              .then(response => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch(err => console.log(err));
          } else if (this.group2 == "PmeMaster") {
            // window.open(
            //   `${subPath.slice(
            //     0,
            //     -1
            //   )}${API_ENDPOINT}/employmee-masterfile-info/${data}`
            // );

            var nameOfTheCsv = "PmeLevelReport.xlsx";
            this.$axios
              .get(`${API_ENDPOINT}/pme-level-setup/${data}`, {
                responseType: "blob"
              })
              .then(response => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch(err => console.log(err));
          } else {
            window.open(
              `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                data.reportCode
              }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                data.companyKey
              }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
                data.logoAlign
              }&logoWidth=${data.logoWidth}&paramKey=${data.paramKey}&rpt=${
                data.rpt
              }`
            );
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {},
  watch: {
    reportType(val) {
      if (val == "emp") {
        this.group2 = "Personal";
      } else {
        this.group2 = "Employment";
      }
    }
  }
};
</script>
